// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3KqOf","header":"MergedInvoice_header__3jwmX"};